import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type StructuredSessionId } from '@backrs_ui/grow-ui/src/models/models';

import { logout } from '../session/logoutThunk';
import type { RootState } from '../store';
import { closeCustomTab } from '../tabs/tabs.slice';

export type SelectedSolutionSession = Readonly<{
  sessionType: StructuredSessionId;
  sessionId: number;
  title: string;
}>;

type MemberSolutionSessionState = Readonly<{
  selected: SelectedSolutionSession | null;
}>;

const initialState: MemberSolutionSessionState = { selected: null };

export const memberSolutionSessionSlice = createSlice({
  name: 'memberSolutionSession',
  initialState,
  reducers: {
    setMemberSolutionSession: (state, action: PayloadAction<SelectedSolutionSession>) => {
      state.selected = action.payload;
    },
    clearMemberSolutionSession: (state) => {
      state.selected = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
    // the selection is what the tab renders, so it can't outlive the tab
    builder.addCase(closeCustomTab, (state, action) => {
      if (action.payload === 'memberSolutionSession') {
        state.selected = null;
      }
    });
  },
});

export const { setMemberSolutionSession, clearMemberSolutionSession } =
  memberSolutionSessionSlice.actions;

export const memberSolutionSessionReducer = memberSolutionSessionSlice.reducer;

export const selectSelectedMemberSolutionSession = (
  state: RootState,
): SelectedSolutionSession | null => state.memberSolutionSession.selected;
